import { useEffect, useRef, useState } from 'react'

export interface RailHoverGeometry {
  anchor: DOMRect
  card: DOMRect
}

// Placed against the edge of the closest `data-rail-card`, or of the icon itself without one.
const useRailHoverLabel = <T extends HTMLElement = HTMLDivElement>() => {
  const anchorRef = useRef<T>(null)
  const [geometry, setGeometry] = useState<RailHoverGeometry | null>(null)

  const show = () => {
    const anchor = anchorRef.current
    if (!anchor) return
    const anchorRect = anchor.getBoundingClientRect()
    const card = anchor.closest('[data-rail-card]')
    setGeometry({ anchor: anchorRect, card: card?.getBoundingClientRect() ?? anchorRect })
  }

  const hide = () => setGeometry(null)

  // A click often resizes the menu under the pointer, and Safari sends no mouseleave until the pointer moves again.
  useEffect(() => {
    if (!geometry) return undefined
    const anchor = anchorRef.current
    window.addEventListener('scroll', hide, true)
    anchor?.addEventListener('click', hide)
    return () => {
      window.removeEventListener('scroll', hide, true)
      anchor?.removeEventListener('click', hide)
    }
  }, [geometry])

  return { anchorRef, geometry, show, hide }
}

export default useRailHoverLabel
